import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-up-left-icon',
  templateUrl: './navigation-up-left.component.html'
})
export class NavigationUpLeftComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
